import { render, staticRenderFns } from "./InfluencerCard.vue?vue&type=template&id=37fc8a54&scoped=true&"
import script from "./InfluencerCard.vue?vue&type=script&lang=js&"
export * from "./InfluencerCard.vue?vue&type=script&lang=js&"
import style0 from "./InfluencerCard.vue?vue&type=style&index=0&id=37fc8a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fc8a54",
  null
  
)

export default component.exports